package com.macrofocus.eflux.ui.svg

import org.mkui.geom.PathIterator

class SVGPathBuilder(iterator: PathIterator) {
    var builder : StringBuilder? = null

    init {
        beginPath()
        append(iterator)
    }

    fun append(iterator: PathIterator) {
        val coords = DoubleArray(6)
        while (!iterator.isDone) {
            when (val segment: Int = iterator.currentSegment(coords)) {
                PathIterator.SEG_MOVETO -> {
                    moveTo(coords[0], coords[1])
                }
                PathIterator.SEG_LINETO -> {
                    lineTo(coords[0], coords[1])
                }
                PathIterator.SEG_QUADTO -> {
                    quadraticCurveTo(coords[0], coords[1], coords[2], coords[3])
                }
                PathIterator.SEG_CUBICTO -> {
                    bezierCurveTo(coords[0], coords[1], coords[2], coords[3], coords[4], coords[5])
                }
                PathIterator.SEG_CLOSE -> {
                    closePath()
                }
                else -> {
                    throw RuntimeException("Unknown Segment $segment")
                }
            }
            iterator.next()
        }
    }

    fun beginPath() {
        builder = StringBuilder()
    }

    override fun toString(): String {
        return builder.toString()
    }

    fun moveTo(x: Double, y: Double) {
        if(builder!!.isNotEmpty()) {
            builder!!.append(" ")
        }
        builder!!.append("M $x $y")
    }

    fun lineTo(x: Double, y: Double) {
        if(builder!!.isNotEmpty()) {
            builder!!.append(" ")
        }
        builder!!.append("L $x $y")
    }

    fun quadraticCurveTo(cpx: Double, cpy: Double, x: Double, y: Double) {
        if(builder!!.isNotEmpty()) {
            builder!!.append(" ")
        }
        builder!!.append("Q $cpx $cpy $x $y")
    }

    fun bezierCurveTo(cp1x: Double, cp1y: Double, cp2x: Double, cp2y: Double, x: Double, y: Double) {
        if(builder!!.isNotEmpty()) {
            builder!!.append(" ")
        }
        builder!!.append("C $cp1x $cp1y $cp2x $cp2y $x $y")
    }

    fun closePath() {
        if(builder!!.isNotEmpty()) {
            builder!!.append(" ")
        }
        builder!!.append("Z")
    }
}